import toast from 'react-hot-toast';
import { getErrorMessage } from './apiClient';

/**
 * Run an upload behind one "Uploading name… N%" toast that ends as success or
 * error. `upload(onProgress)` receives the percent callback. Rethrows failures.
 */
export async function withUploadToast(name, upload) {
  const id = toast.loading(`Uploading ${name}… 0%`);
  try {
    const result = await upload((percent) =>
      toast.loading(`Uploading ${name}… ${percent}%`, { id }),
    );
    toast.success(`Uploaded ${name}`, { id });
    return result;
  } catch (error) {
    toast.error(getErrorMessage(error, `Failed to upload ${name}`), { id });
    throw error;
  }
}
